import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminEntryPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Sesión iniciada");
      navigate("/");
    } else {
      setError(res.error || "Error");
    }
  };

  if (user && user.id) {
    return (
      <div className="bg-[#F8FAFC] min-h-[70vh] flex items-center justify-center px-5">
        <div className="max-w-md w-full bg-white border border-[#E2E8F0] p-8 text-center">
          <p className="eyebrow mb-2">Sesión activa</p>
          <h1 className="font-serif text-2xl text-[#1A1A1A]">Ya has iniciado sesión como {user.name}</h1>
          <Button onClick={() => navigate("/")} className="mt-4 rounded-none h-11 bg-[#1A1A1A] text-[#F8FAFC]">
            Ir a la portada
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#F8FAFC] min-h-[80vh] flex items-center justify-center px-5">
      <div className="max-w-md w-full bg-white border border-[#E2E8F0] p-10" data-testid="admin-entry">
        <div className="flex items-center gap-2 mb-3">
          <Lock className="w-4 h-4 text-[#3B5FB8]" />
          <p className="eyebrow">Acceso privado</p>
        </div>
        <h1 className="font-serif text-3xl font-semibold text-[#1A1A1A]">Entrada de administración</h1>
        <p className="mt-2 text-sm text-[#475569]">
          Sólo para el equipo de buscocompartir. Si has llegado aquí por error, vuelve a la
          <button onClick={() => navigate("/")} className="link-underline text-[#3B5FB8] font-semibold ml-1">portada</button>.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-xs font-mono uppercase tracking-[0.15em] text-[#475569]">Email</Label>
            <Input
              data-testid="admin-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none h-11 border-[#CBD5E1] mt-1.5 bg-white"
            />
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-[0.15em] text-[#475569]">Contraseña</Label>
            <Input
              data-testid="admin-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none h-11 border-[#CBD5E1] mt-1.5 bg-white"
            />
          </div>
          {error && <p data-testid="admin-error" className="text-sm text-red-700 border border-red-200 bg-red-50 px-3 py-2">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full rounded-none h-12 bg-[#1A1A1A] hover:bg-[#2A2A2A] text-[#F8FAFC]">
            {busy ? "Entrando..." : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
